import { Navigate, BrowserRouter as Router, useRoutes } from 'react-router-dom';
import React, { Suspense } from 'react';
import './App.scss';
import AuthProvider from './modules/shared/utilities/authProvider';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Auth = React.lazy(() => import('./modules/authentication/authentication'));
const Layout = React.lazy(() => import('./modules/employee/layout'));
const Admin = React.lazy(() => import('./modules/admin/admin'));
const Paths = () => {
  let routes = useRoutes([
    { path: "/employee/*", element: <Layout /> },
    {
      path: '/admin/*',
      element: (
        <AdminRoute>
          <Admin />
        </AdminRoute>
      ),
    },
    { path: "*", element: <Auth />, exact: true }
  ]);
  return routes;
}

const AdminRoute = ({ children }) => {
  const isAuthenticated = true;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  } 

  return children;
};


function App() {
  return (
    <Router>
      <AuthProvider>
        <Suspense fallback={<div>Loading...</div>}>
          <Paths></Paths>
          {/* ✅ Toast container (ONLY ONCE) */}
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
          />
        </Suspense>
      </AuthProvider>
    </Router>
  );
}

export default App;
